import React from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import clsx from "clsx";

import styles from "./index.module.css";
const Step3 = () => {
    const history = useHistory();
    return (
        <div className={styles.step3Page}>
            <Paper className={styles.paper}>
                <Text className="mt-0" type={"h1"}>
                    Acest formular are 5 pași:
                </Text>
                <Text className="mt-0" type={"h3"}>
                    1. Selectarea Direcției de interes;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    2. Selectarea tipului de serviciu necesar;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    3. Alegere dată și oră;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    4. Introducere date personale
                </Text>
                <Text className="mt-0" type={"h3"}>
                    5. Confirmarea numărului de telefon.
                </Text>
                <Text className="mt-0" type={"h3"}></Text>
                <Text className="mt-0" type={"h3"}>
                    Timp estimat necesar: 4 minute
                </Text>
            </Paper>
            <Paper className={styles.paper}>
                <Text className="mt-0" type={"h1"}>
                    Te rugăm să ai la îndemână:
                </Text>
                <Text className="mt-0" type={"h3"}>
                    • Codul Numeric Personal (CNP);
                </Text>
                <Text className="mt-0" type={"h3"}>
                    • Acces la un număr de telefon mobil;
                </Text>
                <Text className="mt-0" type={"h3"}>
                    • O adresă de email (opțional, dar recomandat).
                </Text>
                <div
                    className={clsx(
                        styles.actionContainer,
                        styles.alignCenter,
                        styles.spaceBtw
                    )}
                >
                    <Button
                        className={styles.prevButton}
                        size="large"
                        variant="secondary"
                        label="<- înapoi"
                        onClick={() => history.push("/programare/step2")}
                    />
                    <Button
                        className={styles.nextButton}
                        size="large"
                        label="Continuă ->"
                        onClick={() => history.push("/programare/step4")}
                    />
                </div>
            </Paper>
        </div>
    );
};

export default Step3;
